import React, { useState, useCallback, useRef, useEffect } from "react";
import { Grid } from "@mui/material";
import { faExpand, faMinus } from "@fortawesome/free-solid-svg-icons";
import { ChartsToggler, ChartsInnerContainer } from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Props } from "./interfaces";
import ChartsTogglerPortal from "./ChartsTogglerPortal";
import { SPACING } from "../../../_globalStore/redux/reducers/Theme/themeConstants";

const ChartsContainer = ({ charts, handleNotifyOnChartResize }: Props) => {
  const [state, setState] = useState({
    expanded: false,
  });

  const handleExpandCharts = useCallback(() => {
    if (state.expanded) {
      setState((state) => ({
        ...state,
        expanded: false,
      }));
      setTimeout(() => {
        handleNotifyOnChartResize && handleNotifyOnChartResize(220);
      }, 400);
    } else {
      handleNotifyOnChartResize && handleNotifyOnChartResize(-220);

      setTimeout(() => {
        setState((state) => ({
          ...state,
          expanded: true,
        }));
      }, 350);
    }
  }, [handleNotifyOnChartResize, state.expanded]);

  const [displayToggler, setDisplayToggler] = useState<boolean>(false);

  return charts ? (
    <Grid>
      <ChartsTogglerPortal
        toggler={
          <ChartsToggler
            hidden={state.expanded}
            onClick={handleExpandCharts}
            effect={"expand"}
          >
            <FontAwesomeIcon icon={faExpand} />
          </ChartsToggler>
        }
      />

      <ChartsInnerContainer
        onMouseEnter={() => {
          setDisplayToggler(true);
        }}
        onMouseLeave={() => {
          setDisplayToggler(false);
        }}
        in={state.expanded}
        orientation={"vertical"}
        collapsedSize={"0px"}
        style={{
          marginBottom: state.expanded ? SPACING[7] : "0px",
          maxHeight: "220px", //please change the height passed with handleNotifyOnChartResize when changing this
        }}
      >
        <ChartsToggler
          hidden={!displayToggler && state.expanded}
          onClick={handleExpandCharts}
          effect={"close"}
        >
          <FontAwesomeIcon icon={faMinus} />
        </ChartsToggler>
        {charts}
      </ChartsInnerContainer>
    </Grid>
  ) : (
    <></>
  );
};
export default ChartsContainer;
